import { createColumnHelper } from "@tanstack/react-table";
import {
  ActivityQuery,
  AuthConfig,
  ControlCodes,
  createRecordFromKey,
  EndpointActivity,
  getControlName,
  Platform,
  Probe,
  queries,
  useAuthConfig,
} from "@theprelude/core";
import {
  edrColumn,
  hostSmallColumn,
  osColumn,
  platformColumn,
  protectedColumn,
} from "@/components/table/columns";
import { createQuery } from "@/lib/create-query";
import { isValidControl } from "@/lib/validators";
import QuickViewTable from "./quickview-table";

interface QuickviewNoEDR {
  endpoint_id: string;
  name: string;
  dos?: Platform;
  os?: string;
  protected?: number;
  control?: string;
}

function getEndpointsData(
  endpoints: Probe[],
  endpointActivity: EndpointActivity[],
): QuickviewNoEDR[] {
  const endpointActivityById = createRecordFromKey(
    endpointActivity,
    "id",
    "protected",
  );
  return endpoints
    .filter((e) => e.control === ControlCodes.NONE)
    .map((e) => {
      return {
        endpoint_id: e.endpoint_id,
        name: e.host,
        dos: e.dos ?? undefined,
        os: e.os ?? undefined,
        protected: endpointActivityById[e.endpoint_id],
        control: isValidControl(e.control)
          ? getControlName(e.control)
          : undefined,
      };
    });
}

const endpointsQuery = (authConfig: AuthConfig, query: ActivityQuery) =>
  createQuery({
    queries: [
      queries.detect.endpoints(authConfig, 90),
      queries.detect.activity.endpoints(authConfig, query),
    ],
    queryFn: getEndpointsData,
  });

const columnHelper = createColumnHelper<QuickviewNoEDR>();

const columns = [
  columnHelper.accessor("name", hostSmallColumn),
  columnHelper.accessor("dos", platformColumn),
  columnHelper.accessor("os", osColumn),
  columnHelper.accessor("protected", protectedColumn),
  columnHelper.accessor("control", edrColumn),
];

export function NoEDRTable({ query }: { query: ActivityQuery }) {
  const authConfig = useAuthConfig();
  const queryInfo = endpointsQuery(authConfig, query).useQuery();
  return (
    <>
      <QuickViewTable
        name="quickview-no-edr"
        data={queryInfo.data ?? []}
        columns={columns}
        isLoading={queryInfo.isLoading}
      />
    </>
  );
}
